import { render, staticRenderFns } from "./code.vue?vue&type=template&id=5b2e83fe&scoped=true&"
import script from "./code.vue?vue&type=script&lang=js&"
export * from "./code.vue?vue&type=script&lang=js&"
import style0 from "./code.vue?vue&type=style&index=0&id=5b2e83fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2e83fe",
  null
  
)

export default component.exports